import { useEffect } from "react";

export default function HighlightPulse({
  children,
  setIsActive,
  isActive = false,
  shouldDisable = false,
  pulses = 3,
  pulseColor = "ring-indigo-400",
  glowColor = "shadow-indigo-400/50",
  borderRadius = "rounded-lg",
}) {
  useEffect(() => {
    if (isActive && setIsActive) {
      // Each pulse is 1000ms but for some reason after the last pulse,
      // an extra one begins, so the 100 helps us avoid that
      const duration = pulses * 1000 - 100;
      const timer = setTimeout(() => {
        setIsActive(false);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isActive, setIsActive, pulses]);

  if (!isActive || shouldDisable) {
    return children;
  }

  return (
    <div className={`relative ${borderRadius}`}>
      <div
        className={`absolute inset-0 ${borderRadius} animate-ping ring-2 ${pulseColor} ${glowColor} shadow-lg pointer-events-none`}
      />
      {children}
    </div>
  );
}
